import React from 'react';
import { useIntl } from 'react-intl';

import { useAuth0 } from '@auth0/auth0-react';

import { ButtonColors } from 'constant';

import Button from 'components/ui/Button';

import {
  Wrapper,
  StyledLoginButton
} from './AutenticateButton.styles';

export interface AutenticateButtonProps {
  mobileShow?: boolean;
}

const AutenticateButton = ({ mobileShow = false }: AutenticateButtonProps) => {
  const intl = useIntl();

  const { isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const logoutWithRedirect = () => logout({
    logoutParams: {
      returnTo: window.location.origin
    }
  });

  return (
      <Wrapper mobileShow={mobileShow}>
        {!isAuthenticated ? (
          <React.Fragment>
            <StyledLoginButton
              color={mobileShow ? ButtonColors.SecondaryDark: ButtonColors.Secondary}
              onClick={() => loginWithRedirect()}
            >
              {intl.formatMessage({ id: 'header.loginButton' })}
            </StyledLoginButton>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Button
              color={mobileShow ? ButtonColors.SecondaryDark : ButtonColors.Secondary}
              onClick={() => logoutWithRedirect()}
            >
              {intl.formatMessage({ id: 'header.logout' })}
            </Button>
          </React.Fragment>
        )}
      </Wrapper>
  );
};

export default AutenticateButton;
